module.exports = __webpack_public_path__ + "static/media/snooze.ffc45822.svg";